import React from 'react';
import { withAppContext, getToken } from '@ctsu/loader';
import { withStyles } from '@material-ui/core/styles';
import http from 'helpers/APIHelper';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setProtocol } from 'actions/protocols';
import { getSessionByKey } from 'helpers';
import { AutoStyles, AutoDownshift } from './AutoComplete';

class ProtocolAutoComplete extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      suggestions: undefined,
      selProtocol: null
    };
    this.autoCompleteRef = React.createRef();
    this.getSuggestions = this.getSuggestions.bind(this);
    this.downshiftOnChange = this.downshiftOnChange.bind(this);
  }

  getSuggestions(event) {
    if (!event.target.value) {
      return;
    }
    const { context } = this.props;
    const {
      logInfo, logDebug, logError, logFatal
    } = context;
    const token = getToken();

    const { ...loggerInfo } = {
      logInfo, logDebug, logError, logFatal
    };

    http
      .postWithToken(
        `protocol-data-service/${
          getSessionByKey('prt_url_ver')
        }/protocols/number/autocomplete`,
        token,
        loggerInfo,
        event.target.value.trim()
      )
      .subscribe(resp => {
        this.setState((prevState) => {
          return {
          ...prevState,
          suggestions: resp.response
        }});
      });
  }

   handleSearchClick = event => {
     event.preventDefault();
     const { suggestions } = this.state;
     if (suggestions && suggestions.length >= 1) {
       this.downshiftOnChange(suggestions[0]);
     }
   }


 handleEnterKeyPress = event => {
   if (event.keyCode === 13) {
     event.preventDefault();
     const selectedSuggestion = event.target.value.trim();
     const { suggestions } = this.state;
     if (suggestions.length > 1) {
       const regex = new RegExp(suggestions.join('|'), 'i');
       if (regex.test(selectedSuggestion)) {
         this.downshiftOnChange(selectedSuggestion);
       } else {
         this.downshiftOnChange(suggestions[0]);
       }
     } else if (suggestions.length === 1) {
       this.downshiftOnChange(suggestions[0]);
     }
   }
 }

 downshiftOnChange(suggestion) {
   const { protocol, onSetProtocol } = this.props;
   const { selPrtTab } = protocol;
   const tab = selPrtTab || '/protocoldetail';
   onSetProtocol({ id: suggestion, tab });
   this.setState((prevState) => {
    return {
    ...prevState,
    selProtocol: suggestion
  }});
  setTimeout(() => {
    this.setState((prevState) => {
      return {
      ...prevState,
      selProtocol: ''
    }});
    const node = this.autoCompleteRef.current.getElementsByTagName('input')[0];
    node.blur();
  }, 1000);
 }

 render() {
   const { classes } = this.props;
   const { suggestions, selProtocol } = this.state;
   return (
     <div  ref={this.autoCompleteRef} className={`${classes.root} global-search`}>
       <AutoDownshift
         selectedValue={selProtocol}
         placeholderText="Search Protocol"
         downshiftOnChange={this.downshiftOnChange}
         classes={classes}
         name="search_protocol"
         handleSearchClick={this.handleSearchClick}
         getSuggestions={this.getSuggestions}
         handleEnterKeyPress={this.handleEnterKeyPress}
         suggestions={suggestions}
         suggestionSize="80vh"
       />
       <div className={classes.divider} />
     </div>
   );
 }
}

const withConnectState = connect(
  (state, ownProps) => ({
    protocol: state.protocol
  }),
  dispatch => bindActionCreators(
    {
      onSetProtocol: setProtocol
    },
    dispatch
  )
);

export default compose(
  withStyles(AutoStyles),
  withConnectState,
  withAppContext
)(ProtocolAutoComplete);
